import React from 'react';
import { motion } from 'framer-motion';
import { ChatBubble } from './Icons';
interface FinalCTAProps {
  lang: 'en' | 'es';
}
export const FinalCTA: React.FC<FinalCTAProps> = ({
  lang
}) => {
  const content = {
    en: {
      title: 'Ready to find your perfect car?',
      btn: 'Fill Out the Form'
    },
    es: {
      title: '¿Listo para encontrar tu auto perfecto?',
      btn: 'Llena el Formulario'
    }
  };
  const t = content[lang];
  const scrollToForm = () => {
    const form = document.getElementById('quote-form');
    if (form) {
      form.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-24 px-6 bg-primary text-center" data-id="element-8">
      <div className="max-w-3xl mx-auto" data-id="element-9">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-white mb-10" data-id="element-10">
          {t.title}
        </motion.h2>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} onClick={scrollToForm} className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-transparent border-2 border-white text-white rounded-full font-bold text-lg hover:bg-white hover:text-primary transition-colors" data-id="element-11">
          <ChatBubble size={24} data-id="element-12" />
          {t.btn}
        </motion.button>
      </div>
    </section>;
};